import React from 'react';

import BaseLandingPage from 'components/landing/BaseLandingPage';

const SellerLandingPage: React.FC = () => {
  return (
    <BaseLandingPage
      headerText="Get more orders"
      subHeaderText="Get more sales without having to get a bigger sales team"
      callToActionText="Sign up"
      callToActionLink="https://sansantech.vercel.app/sign-up"
    />
  );
};

export default SellerLandingPage;
